import React, { useState } from "react";
import { MdOutlineDragIndicator } from "react-icons/md";
import { Draggable } from "react-beautiful-dnd";
import { Modal, Input, message } from "antd";
import CopyComponent from "../../../../components/CopyComponent/CopyComponent";
import StatusSelector from "../../../../components/StatusSelector/StatusSelector";
import { Button } from "antd";
import SubComponents from "../../StayUpToDate/StayUpToDateComponents/SubComponents";
import EditMyLinks from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/EditMyLinks";
import EditAddLinks from "../../StayUpToDate/LandingPageComponents/LinksComponent/EditAddLinks";
import EditHighlightLinks from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/EditHighlightLinks";
import EditCustomBanner from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/EditCustomBanner";
import EditTrendingProducts from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/TrendingProducts/EditTrendingProducts";
import EditQueryBasedCarousel from "../QueryBasedCarousel/EditQueryBasedCarousel";
import EditYesterdayContent from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/EditYesterdayContent";
import EditProductBank from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/EditProductBank";
import EditYesterdayLinks from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/EditYesterdayLinks";
import EditCustomLinks from "../CustomCarousel/EditCustomLinks";
import EditCustomContent from "../CustomCarousel/EditCustomContent";
import EditContentTypePosts from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/ContentTypePosts/EditContentTypePosts";
import EditTrendingContent from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/TrendingContent/EditTrendingContent";
import { isNavigable } from "../../../../Utils/StayUpToDate/RenderComponent";
import { updateRoute } from "../../../../Utils/SupabaseServices/StayUpToDateDatabase"; // Add this import
import EditRouteModal from "../../StayUpToDate/StayUpToDateComponents/EditTemplates/EditRouteModal";
import { MdExpandMore, MdExpandLess } from "react-icons/md";
import { IoExpand } from "react-icons/io5";
import { BiCollapse } from "react-icons/bi";
import { IoTrashOutline } from "react-icons/io5";

interface SubComponentsWrapperProps {
  user_id: string;
  username: string;
  component: any;
  refetch: () => void;
  brand_color: string;
  handleDelete: (name: string) => void;
  refatchStayUpToDate: () => void;
  setStatus: (status: string) => void;
  selectedComponent: any;
  setSelectedComponent: (component: any) => void;
  isEdit: boolean;
  setIsEdit: (isEdit: boolean) => void;
  isEditModalOpen: boolean;
  setIsEditModalOpen: (isOpen: boolean) => void;
  from: string;
  index: number;
  isMaximized?: boolean;
}

const SubComponentsWrapper: React.FC<SubComponentsWrapperProps> = (props) => {
  const {
    user_id,
    username,
    component,
    refetch,
    brand_color,
    handleDelete,
    refatchStayUpToDate,
    setStatus,
    selectedComponent,
    setSelectedComponent,
    isEdit,
    setIsEdit,
    isEditModalOpen,
    setIsEditModalOpen,
    from,
    index,
    isMaximized,
  } = props;

  const [isExpanded, setIsExpanded] = useState(false);

  // Existing state
  const [activeModal, setActiveModal] = useState<
    | null
    | "content"
    | "links"
    | "links-section"
    | "my-links"
    | "form"
    | "query-based"
    | "trending-products"
    | "trending-content"
    | "week-content"
    | "yesterday-links"
    | "daywise"
    | "product-bank"
    | "banner"
    | "highlight"
    | "content-type-posts"
  >(null);
  const [isAddLinkEditModalOpen, setIsAddLinkEditModalOpen] = useState(false);
  const [isMyLinkEditModalOpen, setIsMyLinkEditModalOpen] = useState(false);
  const [isQueryLinksEditModalOpen, setIsQueryLinksEditModalOpen] =
    useState(false);
  const [isTrendingProductsEditModalOpen, setIsTrendingProductsEditModalOpen] =
    useState(false);
  const [isYesterdayLinksEditModalOpen, setIsYesterdayLinksEditModalOpen] =
    useState(false);
  const [isYesterdayContentEditModalOpen, setIsYesterdayContentEditModalOpen] =
    useState(false);
  const [isProductBankEditModalOpen, setIsProductBankEditModalOpen] =
    useState(false);
  const [isBannerEditModalOpen, setIsBannerEditModalOpen] = useState(false);
  const [isHighlightEditModalOpen, setIsHighlightEditModalOpen] =
    useState(false);
  const [edit, setEdit] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  const [initialContent, setInitialContent] = useState(false);
  const [initialLinks, setInitialLinks] = useState(false);
  const [initial, setInitial] = useState(false);
  const [isFormEditModalOpen, setIsFormEditModalOpen] = useState(false);
  const [isContentTypePostsEditModalOpen, setIsContentTypePostsEditModalOpen] =
    useState(false);
  const [isTrendingContentEditModalOpen, setIsTrendingContentEditModalOpen] =
    useState(false);
  const [isDaywiseEditModalOpen, setIsDaywiseEditModalOpen] = useState(false);
  const [contentType, setContentType] = useState("");
  const [platform, setPlatform] = useState("");

  // NEW: Route edit modal state
  const [showRouteModal, setShowRouteModal] = useState(false);
  const [routeEditComponent, setRouteEditComponent] = useState<any>(null);
  const [route, setRoute] = useState("");
  // const [saving, setSaving] = useState(false);
  const [routeError, setRouteError] = useState<string>("");
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Add window resize listener
  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Check if screen is below 445px
  const isSmallScreen = windowWidth <= 445;

  // NEW: Handle route edit modal
  const openRouteModal = (component: any) => {
    setRouteEditComponent(component);
    setRoute(component.route_name || component.unique_id || "");
    setRouteError("");
    setShowRouteModal(true);
  };

  const closeRouteModal = () => {
    setShowRouteModal(false);
    setRouteEditComponent(null);
    setRoute("");
    setRouteError("");
  };

  async function handleEdit(name: any) {
    if (name.type === "content") {
      setActiveModal("content");
    } else if (name.type === "links") {
      setActiveModal("links");
    } else if (name.type === "links-section") {
      setActiveModal("links-section");
    } else if (name.type === "my-links" || name.display_name === "My Links") {
      setActiveModal("my-links");
    } else if (name.type === "form" || name.display_name === "Form") {
      setActiveModal("form");
    } else if (name.type === "query-links" || name.type === "query-content") {
      setActiveModal("query-based");
    } else if (name.type === "trending products") {
      setActiveModal("trending-products");
    } else if (name.type === "trending content") {
      setActiveModal("trending-content");
    } else if (name.display_name === "This Week Content") {
      setActiveModal("week-content");
    } else if (
      name.display_name.split(",").includes("Yesterday") ||
      name.display_name.split(",").includes("This Week") ||
      // name.display_name.split(",").includes("This Week Content") ||
      name.display_name.split(",").includes("This Month")
    ) {
      setActiveModal("yesterday-links");
    } else if (
      name.display_name.split(",").includes("Monday") ||
      name.display_name.split(",").includes("Tuesday") ||
      name.display_name.split(",").includes("Wednesday") ||
      name.display_name.split(",").includes("Thursday") ||
      name.display_name.split(",").includes("Friday") ||
      name.display_name.split(",").includes("Saturday") ||
      name.display_name.split(",").includes("Sunday") ||
      name.display_name.split(",").includes("This Weekend")
    ) {
      setActiveModal("daywise");
    } else if (name.type === "product-bank") {
      setActiveModal("product-bank");
    } else if (name.type === "banner") {
      setActiveModal("banner");
    } else if (name.type === "highlight") {
      setActiveModal("highlight");
    } else if (
      name.display_name === "reels" ||
      name.display_name === "tiktok" ||
      name.display_name === "youtube" ||
      name.display_name === "podcast" ||
      name.display_name === "twitter" ||
      name.display_name === "featured" ||
      name.display_name === "instagram story" ||
      name.display_name === "linkedin"
    ) {
      if (name.display_name === "reels") {
        setContentType("REELS");
        setPlatform("instagram");
      } else if (name.display_name === "tiktok") {
        setContentType("TIKTOK");
        setPlatform("tiktok");
      } else if (name.display_name === "youtube") {
        setContentType("VIDEO");
        setPlatform("youtube");
      } else if (name.display_name === "podcast") {
        setContentType("PODCAST");
        setPlatform("podcast");
      } else if (name.display_name === "twitter") {
        setContentType("TWEET");
        setPlatform("twitter");
      } else if (name.display_name === "featured") {
        setContentType("FEATURE");
        setPlatform("featured");
      } else if (name.display_name === "linkedin") {
        setContentType("POST");
        setPlatform("linkedin");
      } else if (name.display_name === "instagram story") {
        setContentType("STORY");
        setPlatform("instagram");
      }
      setActiveModal("content-type-posts");
    }

    setSelectedComponent(name);
  }

  const ComponentName = (component: any) => {
    return (
      <>
        {component.type !== "banner" && component.type !== "highlight" && (
          <div className="component-name-container">
            <span
              className="component-name"
              style={{
                cursor: isNavigable(component) ? "pointer" : "default",
              }}
            >
              {component.display_name === "Form" && component.name === "Form"
                ? ""
                : component.name}
            </span>
          </div>
        )}
      </>
    );
  };
  const ComponentNameMinimized = (component: any) => {
    return (
      <>
        {/* {component.type !== "banner" && component.type !== "highlight" && ( */}
          <div
            className="component-name-container"
            // style={{
            //   // border: "1px solid red",
            //   width: "100%",
            //   paddingLeft: "0px",

            // }}
            style={{
              width: "100%",
              display: "block",
              paddingLeft: "0.2rem",
              gridColumn: "1 / -1",
              // paddingBottom: "20px",
              marginBottom: "0px",
            }}
          >
            <p
              className="component-name"
              style={{
                cursor: isNavigable(component) ? "pointer" : "default",
              }}
            >
              {component.display_name === "Form" && component.name === "Form"
                ? ""
                : component.name}
            </p>
          </div>
        {/* )} */}
      </>
    );
  };
  return (
    <>
      <Draggable draggableId={component.id.toString()} index={index}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            style={{
              ...provided.draggableProps.style,
              transition: "none",
              boxShadow: "rgba(0, 0, 0, 0.2) 0px 0px 1px",
              border: "1px solid rgba(0, 0, 0, 0.1)",
              borderRadius: "15px",
              padding: "5px !important",
              marginBottom: "10px",
            }}
            className={`component-content `}
            // snapshot.isDragging ? "dragging" : ""
            // }`}
          >
            <div className="component-item" style={{paddingBottom: isMaximized ? "25px" : "10px"}}>
              <div
                {...provided.dragHandleProps}
                className="component-text"
                style={{
                  cursor: "grab",
                  display: "flex",
                  alignItems: "center",
                  padding: "4px",
                  touchAction: "none",
                  width: "max-content",
                  WebkitTouchCallout: "none",
                  WebkitUserSelect: "none",
                  userSelect: "none",
                }}
              >
                <MdOutlineDragIndicator
                  className="outline-drag"
                  size={24}
                  style={{ color: "#666" }}
                />
              </div>
              <div className="button-container">
              {isMaximized && (
                  <Button
                    className="edit-btn"
                    onClick={() => setIsExpanded(!isExpanded)}
                    style={{padding:isSmallScreen ? "0px 12px" : "0px 15px"}}
                  >
                    {isSmallScreen ? (
                      isExpanded ?<BiCollapse style={{fontSize: "0.7rem"}}/>
                      : <IoExpand style={{fontSize: "0.7rem"}}/>

                    ) : (
                      isExpanded ? "Collapse" : "Expand"
                    )}
                  </Button>
                )}
                <CopyComponent
                  user_id={user_id}
                  username={username}
                  component={component}
                  onRouteEdit={() => openRouteModal(component)} // Pass the callback
                />
                <StatusSelector
                  defaultValue={component.status}
                  component={component}
                  user_id={user_id}
                  refetch={refetch}
                  setStatus={setStatus}
                  refatchStayUpToDate={refatchStayUpToDate}
                  from={from}
                />
              
                {(component.type === "links" ||
                  component.type === "query-links" ||
                  component.type === "query-content" ||
                  component.type === "links-section" ||
                  component.type === "content" ||
                  component.type === "banner" ||
                  component.type === "highlight" ||
                  component.type === "product-bank" ||
                  component.type === "trending products" ||
                  component.type === "trending content" ||
                  component.display_name === "My Links" ||
                  component.type === "my-links" ||
                  component.display_name === "Form" ||
                  component.type === "form" ||
                  component.display_name.split(",").includes("Monday") ||
                  component.display_name.split(",").includes("Tuesday") ||
                  component.display_name.split(",").includes("Wednesday") ||
                  component.display_name.split(",").includes("Thursday") ||
                  component.display_name.split(",").includes("Friday") ||
                  component.display_name.split(",").includes("Saturday") ||
                  component.display_name.split(",").includes("Sunday") ||
                  component.display_name.split(",").includes("This Weekend") ||
                  component.display_name.split(",").includes("Yesterday") ||
                  component.display_name.split(",").includes("This Month") ||
                  component.display_name.split(",").includes("This Week") ||
                  component.display_name
                    .split(",")
                    .includes("This Week Content") ||
                  component.display_name === "reels" ||
                  component.display_name === "tiktok" ||
                  component.display_name === "podcast" ||
                  component.display_name === "youtube" ||
                  component.display_name === "twitter" ||
                  component.display_name === "linkedin" ||
                  component.display_name === "instagram story" ||
                  component.display_name === "featured") && (
                  <Button
                    className="edit-btn"
                    onClick={() => {
                      handleEdit(component);
                    }}
                    style={{padding:isSmallScreen ? "0px 12px" : "0px 15px"}}
                  >
                    Edit
                  </Button>
                )}
                <Button
                  className="remove-btn"
                  onClick={() => handleDelete(component.name)}
                  style={{padding:isSmallScreen ? "0px 12px" : "0px 15px"}}
                >
                  {isSmallScreen ? (
                    <IoTrashOutline style={{fontSize: "0.7rem"}} />
                  ) : (
                    "Remove"
                  )}
                </Button>
              </div>
              {isMaximized && !isExpanded && (
               
                <>
                  {ComponentNameMinimized(component)}
                </>
              )}
            </div>

            {/* Name container: only one is shown at a time, always in the same spot */}
            {(!isMaximized || isExpanded) && (
              <>
                {ComponentName(component)}
              </>
            )}

            {/* Content only shown if not minimized or if expanded */}
            {(!isMaximized || isExpanded) && (
              <SubComponents
                user_id={user_id}
                username={username}
                component={component}
                selectedComponent={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                isEdit={isEdit}
                setIsEdit={setIsEdit}
                isEditModalOpen={isEditModalOpen}
                setIsEditModalOpen={setIsEditModalOpen}
                refetch={refetch}
                brand_color={brand_color}
                from={from}
              />
            )}

            {/* All existing edit modals */}
            {activeModal === "content" && (
              <EditCustomContent
                username={username}
                user_id={user_id}
                isContentEditModalOpen={activeModal === "content"}
                setIsContentEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "content" : null)
                }
                type="content"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                initial={initialContent}
                setInitial={setInitialContent}
                from={from}
              />
            )}
            {activeModal === "links" && (
              <EditCustomLinks
                username={username}
                user_id={user_id}
                isLinksEditModalOpen={activeModal === "links"}
                setIsLinksEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "links" : null)
                }
                type="links"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                initial={initialLinks}
                setInitial={setInitialLinks}
                from={from}
              />
            )}

            {activeModal === "product-bank" && (
              <EditProductBank
                username={username}
                user_id={user_id}
                isProductBankEditModalOpen={activeModal === "product-bank"}
                setIsProductBankEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "product-bank" : null)
                }
                type="product-bank"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                initial={initial}
                setInitial={setInitial}
                from={from}
              />
            )}
            {activeModal === "yesterday-links" && (
              <EditYesterdayLinks
                username={username}
                user_id={user_id}
                isYesterdayLinksEditModalOpen={
                  activeModal === "yesterday-links"
                }
                setIsYesterdayLinksEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "yesterday-links" : null)
                }
                type="links"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                from={from}
              />
            )}
            {activeModal === "daywise" && (
              <EditYesterdayLinks
                username={username}
                user_id={user_id}
                isYesterdayLinksEditModalOpen={activeModal === "daywise"}
                setIsYesterdayLinksEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "daywise" : null)
                }
                type="links"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                from={from}
                componentType={"daywise"}
              />
            )}
            {activeModal === "week-content" && (
              <EditYesterdayContent
                username={username}
                user_id={user_id}
                isYesterdayLinksEditModalOpen={activeModal === "week-content"}
                setIsYesterdayLinksEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "week-content" : null)
                }
                type="links"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                from={from}
              />
            )}
            {activeModal === "query-based" && (
              <EditQueryBasedCarousel
                username={username}
                user_id={user_id}
                isQueryLinksEditModalOpen={activeModal === "query-based"}
                setIsQueryLinksEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "query-based" : null)
                }
                type="query"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetchDashboard={refetch}
                initial={initial}
                setInitial={setInitial}
                edit={edit}
                setEdit={setEdit}
                editIndex={editIndex}
                setEditIndex={setEditIndex}
                from={from}
              />
            )}
            {activeModal === "trending-products" && (
              <EditTrendingProducts
                username={username}
                user_id={user_id}
                isTrendingProductsEditModalOpen={
                  activeModal === "trending-products"
                }
                setIsTrendingProductsEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "trending-products" : null)
                }
                type="trending products"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetchDashboard={refetch}
                from={from}
              />
            )}
            {activeModal === "trending-content" && (
              <EditTrendingContent
                username={username}
                user_id={user_id}
                isTrendingContentEditModalOpen={
                  activeModal === "trending-content"
                }
                setIsTrendingContentEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "trending-content" : null)
                }
                type="trending content"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetchDashboard={refetch}
                from={from}
              />
            )}

            {activeModal === "banner" && (
              <EditCustomBanner
                username={username}
                user_id={user_id}
                isBannerEditModalOpen={activeModal === "banner"}
                setIsBannerEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "banner" : null)
                }
                type="banner"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                from={from}
              />
            )}
            {activeModal === "highlight" && (
              <EditHighlightLinks
                username={username}
                user_id={user_id}
                isHighlightEditModalOpen={activeModal === "highlight"}
                setIsHighlightEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "highlight" : null)
                }
                type="highlight"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                from={from}
              />
            )}

            {/* <EditMyLinks
              username={username}
              user_id={user_id}
              isMyLinkEditModalOpen={activeModal === "my-links"}
              setIsMyLinkEditModalOpen={(isOpen: boolean) => setActiveModal(isOpen ? "my-links" : null)}
              type="my-link"
              component={selectedComponent}
              setSelectedComponent={setSelectedComponent}
              refetch={refetch}
              from={from}
            /> */}

            {activeModal === "form" && (
              <EditMyLinks
                username={username}
                user_id={user_id}
                isMyLinkEditModalOpen={activeModal === "form"}
                setIsMyLinkEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "form" : null)
                }
                type="form"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                from={from}
              />
            )}
            {activeModal === "links-section" && (
              <EditAddLinks
                username={username}
                user_id={user_id}
                isAddLinkEditModalOpen={activeModal === "links-section"}
                setIsAddLinkEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "links-section" : null)
                }
                type="links-section"
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetch={refetch}
                from={from}
              />
            )}
            {activeModal === "content-type-posts" && (
              <EditContentTypePosts
                username={username}
                user_id={user_id}
                isContentTypePostsEditModalOpen={
                  activeModal === "content-type-posts"
                }
                setIsContentTypePostsEditModalOpen={(isOpen: boolean) =>
                  setActiveModal(isOpen ? "content-type-posts" : null)
                }
                type={contentType}
                component={selectedComponent}
                setSelectedComponent={setSelectedComponent}
                refetchDashboard={refetch}
                platform={platform}
                isPodcast={component.display_name === "podcast"}
                from={from}
              />
            )}
          </div>
        )}
      </Draggable>

      {showRouteModal && (
        <EditRouteModal
          showRouteModal={showRouteModal}
          closeRouteModal={closeRouteModal}
          username={username}
          route={route}
          setRoute={setRoute}
          routeError={routeError}
          setRouteError={setRouteError}
          from={from}
          refetch={refetch}
          routeEditComponent={routeEditComponent}
          user_id={user_id}
        />
      )}
    </>
  );
};

export default SubComponentsWrapper;
